
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { ApiService } from '../../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../../../shared/constants/api-endpoints';
import { LookupKey } from '../../../shared/constants/lookup-keys';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { SharedService } from '../../../shared/services/shared.service';
import { Utils } from '../../../Utils/utils';
import { FieldValue } from '../../../shared/constants/services.enum';

@Component({
  selector: 'app-contact-us',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  form!: FormGroup;
  lookupKey = LookupKey;
  isSubmitting = false;
  lang: string = 'en';
  // This method is used to initialize the class instance using fb
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.lang = this.sharedService.getCurrentLang();
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(150)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(150)]],
      mobile: ['', [Validators.required]],
      countryCode: [null, [Validators.required]],
      category: [null, [Validators.required]],
      message: ['', [Validators.required, Validators.maxLength(1000)]],
    });

    const loginUser = this.sharedService.getUserProfile();
    const fullName = `${loginUser?.['Name English'] ?? loginUser?.['First Name']}`.trim();
    const email = loginUser?.['EMail Addr'] ?? '';
    const phone = loginUser?.['Phone #'] ? Utils.parseMobile(loginUser?.['Phone #'], 'number') : '';
    const cCode = loginUser?.['Phone #'] ? Utils.parseMobile(loginUser?.['Phone #'], 'cc') : '';
    this.form.patchValue({
      name: fullName || '',
      email,
      mobile: phone,
      countryCode: cCode
    });

    if (fullName) {
      this.form.get('name')?.disable({ emitEvent: false });
    }
    if (email) {
      this.form.get('email')?.disable({ emitEvent: false });
    }
    if (phone) {
      this.form.get('mobile')?.disable({ emitEvent: false });
      this.form.get('countryCode')?.disable({ emitEvent: false });
    }
  }

  // This method is used to submit
  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const formValue = this.form.getRawValue();
    const payload = {
      body: {
        ProcessName: 'DC Create Contact Us logs WF',
        Channel: this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        ContactName: formValue.name,
        ContactEmailAddr: formValue.email,
        ContactPhNum: `${formValue.countryCode}${formValue.mobile}`,
        ContactMessage: formValue.message,
        Category: formValue.category
      }
    };

    this.isSubmitting = true;
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.CREATE_CONTACT_US_LOGS, payload)
      .subscribe({
        next: (response: any) => {
          this.isSubmitting = false;
          if (response?.['Error Message'] === null || response?.['Error Message'] === '') {
            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            this.form.patchValue({
              category: null,
              message: ''
            });
            this.form.markAsPristine();
            this.router.navigate([RoutesPath.DASHBOARD]);
          } else {
            this.sharedService.toastMessage('ERROR', 'TECHNICAL_ERROR', 'error');
          }
        },
        error: () => {
          this.isSubmitting = false;
          this.sharedService.toastMessage('ERROR', 'TECHNICAL_ERROR', 'error');
        }
      });
  }
}
